/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "purchase": {
            "nested": {
              "PurchaseError": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "OTHER": 1,
                  "CARD_EXPIRED": 2,
                  "INCORRECT_EXPIRATION": 3,
                  "INVALID_ACCOUNT_NUMBER": 4,
                  "BLACKLISTED_ACCOUNT": 5,
                  "CURRENCY_MISMATCH": 6,
                  "INSUFFICIENT_FUNDS": 7,
                  "MERCHANT_MISMATCH": 8,
                  "MERCHANT_INSUFFICIENT_PERMISSIONS": 9,
                  "LOCATION": 10,
                  "TRANSACTION_LIMIT": 11,
                  "CVV_FAILURE": 12,
                  "AVS_FAILURE": 13,
                  "GATEWAY_TIMEOUT": 14,
                  "INVALID_ACCOUNT": 15
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.purchase?.nested?.PurchaseError) {
  $root.addJSON(jsonData);
}

/**
 * The reason a purchase was declined according to the gateway.
 *
 * SOURCE PurchaseError @ squareup/payments/purchase.proto at 9:1
 */
export const PurchaseError = $root.lookupEnum('squareup.payments.purchase.PurchaseError').values;